import { InputTypes } from "atoms/constants/input-types";
import { SelectOption } from "atoms/forms/select";
import { InputProperties } from "interfaces/forms/input-properties";
import React from "react";

// -----------------------------------------------------------------------------------------
// #region Interfaces
// -----------------------------------------------------------------------------------------

export interface HiddenFieldProps extends Pick<InputProperties, "value"> {
    /**
     * Id value for the id attribute.
     */
    id?: string;

    /**
     * Name value for the name attribute.
     */
    name: string;

    /**
     * Unique identifier used select the underlying <input> for functional/e2e testing
     */
    testId?: string;
    dataTestId?: string;
    label?: string;
    isValid?: boolean;
    options?: SelectOption[];
    onChange?: (e) => void;
    errorMessages?: string[];
}

// #endregion Interfaces

// -----------------------------------------------------------------------------------------
// #region Component
// -----------------------------------------------------------------------------------------

const HiddenField: React.FunctionComponent<HiddenFieldProps> = (
    props: HiddenFieldProps
) => {
    const { id, name, testId, value, dataTestId } = props;

    return (
        <input
            data-test-id={testId ?? dataTestId}
            id={id}
            name={name}
            type={InputTypes.Hidden}
            value={value}
        />
    );
};

// #endregion Component

// -----------------------------------------------------------------------------------------
// #region Export
// -----------------------------------------------------------------------------------------

export default HiddenField;

// #endregion Export
